;(function () {
  'use strict'
  angular.module('deskfy.arts').factory('MemoTemplateRequestService', memoTemplateRequestService)

  /* @ngInject */
  function memoTemplateRequestService () {
    const service = { handlePaginationMemo }

    return service

    /**
     * @returns {Function} A curried function that will handle pagination
     */
    function handlePaginationMemo () {
      let cache = {}

      if (!window.__DeskfyObserver__) {
        /**
         * This object contains values top update the cache object above
         */
        window.__DeskfyObserver__ = {}
      }

      const removeItems = (items, observerKey, itemKey) => {
        const selectedCachedItems = items

        const itemToRemove = window.__DeskfyObserver__[observerKey]

        if (itemToRemove) {
          const filteredItems = selectedCachedItems.filter((item) => {
            return itemToRemove !== item[itemKey]
          })

          window.__DeskfyObserver__[observerKey] = null

          return filteredItems
        }

        return selectedCachedItems
      }

      const updateItems = (updateId, items, observerKey = 'template', updateItem = 'name') => {
        const selectedCachedItems = items
        const updatedItems = selectedCachedItems

        if (updateId) {
          const itemIndex = selectedCachedItems.findIndex(item => {
            return item.id === Number(updateId)
          })

          const updatedItemTitle = window.__DeskfyObserver__[`${observerKey}-${updateId}`]

          if (itemIndex >= 0) {
            updatedItems[itemIndex][updateItem] = updatedItemTitle
          }
        }

        return updatedItems
      }

      const handlePagination = (key, { requestCallback, cacheCallback }, clearCache = false) => {
        if (clearCache) {
          cache = {}
        }

        if (key in cache) {
          cacheCallback(cache, updateItems, removeItems)
        } else {
          requestCallback(cache)
        }
      }

      return handlePagination
    }
  }
})()
